export const NotificationConstant = {

    
    NOTIFICATION_SAGA: "NOTIFICATION_SAGA",
    NOTIFICATION_REQUEST: "NOTIFICATION_REQUEST",
    NOTIFICATION_RESPONSE: "NOTIFICATION_RESPONSE",
    NOTIFICATION_API: "/notifications",

};